export default "__VITE_ASSET__1Xa5UU0W__"